module.exports = __webpack_public_path__ + "static/img/bottom-d-right-new.f4aaf424.png";